import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGraphData } from "../../../redux/Action";
import Chart from "../../../components/common/Chart";
import AttendanceTable3 from "../../../components/common/AttendanceTable3";

const Report3 = () => {
  const dispatch = useDispatch();
  const [datedash2, setDateDash2] = useState(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    dispatch(getGraphData(datedash2));
  }, [datedash2]);

  const handleDate2 = (e) => {
    const selectedDate = e.target.value;
    setDateDash2(selectedDate);
  };
  const handleClearSelection2 = (e) => {
    e.stopPropagation();
    setDateDash2("");
  };

  const getGraphListData = useSelector((state) => state?.main);
  return (
    <div className="pb-5">
      <div>
        {getGraphListData?.getGraphListData?.data && (
          <Chart
            getGraphListData={getGraphListData?.getGraphListData?.data}
            handleDate={handleDate2}
            handleClearSelection={handleClearSelection2}
            datedash={datedash2}
          />
        )}
      </div>

      <div>
        <AttendanceTable3
          getGraphListData={getGraphListData?.getGraphListData?.data}
          datedash2={datedash2}
        />
      </div>
    </div>
  );
};

export default Report3;
